import { Col, Image, Row } from "antd";

const imageUrl =
  "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/80-a-landmark-gift-transforming-kidney-stone-care-in-sri-lanka/nahil-kidney-stone-patient.jpeg";
const centreImageUrl =
  "https://customer-apps-techhq.s3.eu-west-2.amazonaws.com/app-nahil/80-a-landmark-gift-transforming-kidney-stone-care-in-sri-lanka/national_kidney_stone_referral_centre_in_meerigama.jpg";

export const ALandmarkGiftTransformingKidneyStoneCareInSriLanka = () => {
  return (
    <div style={{ padding: "10px" }}>
      <div style={{ textAlign: "center" }}>
        <h1 id="a-landmark-gift-transforming-kidney-stone-care-in-sri-lanka">
          A Landmark Gift Transforming Kidney Stone Care in Sri Lanka
        </h1>
      </div>
      <Row gutter={[24, 24]}>
        <Col xs={24} md={12}>
          <Image
            src={imageUrl}
            alt="Nahil Wijesuriya with a patient at the National Kidney Stone Referral Centre"
            style={{ width: "100%" }}
          />
          <Image
            src={centreImageUrl}
            alt="National Kidney Stone Referral Centre in Meerigama"
            style={{ width: "100%", marginTop: "16px" }}
          />
        </Col>
        <Col xs={24} md={12}>
          <p>
            Renowned philanthropist and business leader Eng. Nahil Wijesuriya
            has donated <strong>Rs. 161 million</strong> worth of modern medical
            equipment required for the newly established National Kidney Stone
            Referral Centre in Meerigama, marking a significant advancement in
            Sri Lanka&apos;s capacity to provide specialized urological care
            through the public healthcare system.
          </p>
          <p>
            Once fully operational, the National Kidney Stone Referral Centre is
            expected to have the capacity to perform more than 1,000 complex
            kidney stone procedures annually. Designed as a national facility,
            the Centre will allow urological surgeons from across Sri Lanka to
            access its specialized equipment and infrastructure to treat their
            own patients, helping extend advanced care beyond individual
            hospitals.
          </p>
          <p>
            Treatment at the Centre will be provided entirely free of charge
            through the Ministry of Health system, strengthening equitable
            access to specialized kidney stone treatment for patients
            irrespective of their geographic or economic circumstances.
          </p>
          <p>
            The Centre was established within just a few months following a
            proposal by the Sri Lanka Association of Urological Surgeons. Its
            rapid development demonstrates the impact that collaboration between
            medical professionals, the state healthcare system and private
            philanthropy can have in addressing critical gaps in specialized
            medical care.
          </p>
          <p>
            With access to modern equipment and dedicated specialist facilities,
            the Centre is expected to improve the management of complex kidney
            stone cases while supporting urologists working across the country.
          </p>
          <p>
            Eng. Wijesuriya&apos;s contribution reflects a broader philanthropic
            approach focused on strengthening institutions and creating
            long-term public benefit, particularly in healthcare and education.
            From supporting advanced paediatric care through Little Hearts to
            enabling specialized urological treatment in Meerigama, his
            investments continue to contribute directly to expanding access to
            essential services in Sri Lanka.
          </p>
          <p>
            The National Kidney Stone Referral Centre is expected to become an
            important national resource, combining specialist expertise,
            advanced medical technology and free access to treatment within Sri
            Lanka&apos;s public health system.
          </p>
          <h2>References</h2>
          <p style={{ lineHeight: 1.8 }}>
            <span>
              <a
                href="https://www.mininewshub.com/en/nahil-wijesuriya-kidney-stone-referral-centre-meerigama"
                target="_blank"
                rel="noreferrer"
              >
                Mini News Hub
              </a>
              {" | "}
            </span>
            <span>
              <a
                href="https://bizenglish.adaderana.lk/a-landmark-gift-transforming-kidney-stone-care-in-sri-lanka/"
                target="_blank"
                rel="noreferrer"
              >
                Ada Derana Biz
              </a>
              {" | "}
            </span>
            <span>
              <a
                href="https://x.com/adaderana_biz/status/2096905172312285256?s=20"
                target="_blank"
                rel="noreferrer"
              >
                Ada Derana Biz - X
              </a>
              {" | "}
            </span>
            <span>
              <a
                href="https://www.instagram.com/p/Dc-34xDlLMx/?utm_source=ig_web_copy_link&stkn=MzRlODBiNWFlZA=="
                target="_blank"
                rel="noreferrer"
              >
                Ada Derana Biz - Instagram
              </a>
              {" | "}
            </span>
            <span>
              <a
                href="https://www.lankabusinessnews.com/nahil-does-it-again-a-landmark-gift-transforming-kidney-stone-care-in-sri-lanka/?fbclid=IwY2xjawULh3lwZG9mBWV4dG4DYWVtAjEwAGJyaWQRMXNLeUJvVFR6Wm9YbDV6aE1zcnRjBmFwcF9pZBAyMjIwMzkxNzg4MjAwODkyAAEeiuIbbppiZ0xTQcpiMZLd4Qm90UDPU0sj1YPxGJv1vwIB8UslTeNWfWN9DMM_aem_0M_TnnV1DDslijeMX5ZYyQ"
                target="_blank"
                rel="noreferrer"
              >
                Lanka Business News
              </a>
              {" | "}
            </span>
            <span>
              <a
                href="https://www.facebook.com/share/p/19TXUrUwJH/"
                target="_blank"
                rel="noreferrer"
              >
                Lanka Business News - Facebook
              </a>
              {" | "}
            </span>
            <span>
              <a
                href="https://www.facebook.com/share/p/1TxkXQrH6E/"
                target="_blank"
                rel="noreferrer"
              >
                CWN - Facebook
              </a>
            </span>
          </p>
        </Col>
      </Row>
    </div>
  );
};
